import * as z from "zod";

export const getConsolidationViewCounts = {
  name: "getConsolidationViewCounts" as const,
  input: z.object({ search: z.string().trim().max(200).nullish() }),
  output: z.object({
    folderCounts: z.record(z.string(), z.number()),
    viewCounts: z.record(z.string(), z.number()),
  }),
};
